var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSocialTwitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16.248,
    viewBox: "0 0 20 16.248",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social_twitter",
    transform: "translate(0.002 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M19.446,3.3a8.242,8.242,0,0,1-2.606,1A4.106,4.106,0,0,0,9.848,8.037,11.649,11.649,0,0,1,1.392,3.75a4.108,4.108,0,0,0,1.27,5.477A4.1,4.1,0,0,1,.8,8.712v.051a4.107,4.107,0,0,0,3.291,4.023,4.115,4.115,0,0,1-1.854.07,4.108,4.108,0,0,0,3.832,2.85,8.234,8.234,0,0,1-5.1,1.756A8.433,8.433,0,0,1,0,17.4a11.617,11.617,0,0,0,6.289,1.844A11.594,11.594,0,0,0,17.961,7.574c0-.177,0-.355-.012-.531A8.269,8.269,0,0,0,20,4.922a8.193,8.193,0,0,1-2.356.646A4.115,4.115,0,0,0,19.446,3.3Z",
    fill: "#0d47a1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSocialTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/social_twitter.09a51a704318e50ae0aad2bc793181b6.svg";